import _objectSpread from "C:\\Users\\surac\\Documents\\GitHub\\tffwebsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import getNavigationActionCreators from './routers/getNavigationActionCreators';
import _getChildNavigation from './getChildNavigation';
import getChildrenNavigationCache from './getChildrenNavigationCache';
export default function getNavigation(router, state, dispatch, actionSubscribers, getScreenProps, getCurrentNavigation) {
  var actions = router.getActionCreators(state, null);
  var navigation = {
    actions: actions,
    router: router,
    state: state,
    dispatch: dispatch,
    getScreenProps: getScreenProps,
    getChildNavigation: function getChildNavigation(childKey) {
      return _getChildNavigation(navigation, childKey, getCurrentNavigation);
    },
    isFocused: function isFocused(childKey) {
      var _getCurrentNavigation = getCurrentNavigation().state,
          routes = _getCurrentNavigation.routes,
          index = _getCurrentNavigation.index;

      if (childKey == null || routes[index].key === childKey) {
        return true;
      }

      return false;
    },
    addListener: function addListener(eventName, handler) {
      if (eventName !== 'action') {
        return {
          remove: function remove() {}
        };
      }

      actionSubscribers.add(handler);
      return {
        remove: function remove() {
          actionSubscribers.delete(handler);
        }
      };
    },
    dangerouslyGetParent: function dangerouslyGetParent() {
      return null;
    },
    isFirstRouteInParent: function isFirstRouteInParent() {
      return true;
    },
    _childrenNavigation: getChildrenNavigationCache(getCurrentNavigation())
  };

  var actionCreators = _objectSpread({}, getNavigationActionCreators(navigation.state), actions);

  Object.keys(actionCreators).forEach(function (actionName) {
    navigation[actionName] = function () {
      return navigation.dispatch(actionCreators[actionName].apply(actionCreators, arguments));
    };
  });
  return navigation;
}